import { render } from "./LeftAreaStations.vue?vue&type=template&id=4b61c580"
import script from "./LeftAreaStations.vue?vue&type=script&lang=js"
export * from "./LeftAreaStations.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "4b61c580"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b61c580', script)) {
    api.reload('4b61c580', script)
  }
  
  module.hot.accept("./LeftAreaStations.vue?vue&type=template&id=4b61c580", () => {
    api.rerender('4b61c580', render)
  })

}

script.__file = "resources/js/UI/LeftAreaStations.vue"

export default script